import $http from "@/api/index";
import axios from "axios";
import { getToken } from "../../../util/auth";
const cookieUser = getToken();
const person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.companyId,
  COMPANYNAME: cookieUser.companyName
};
//修改评分情况
export function UpdateScoreGroup(paras) {
  let getUrl = {
    method: "POST",
    url: "task/UpdateScoreGroup",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}
//获取任务评分情况
export function GetTaskScoreInfo(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskScoreInfo",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}
//保存任务任务评分
export function SaveTaskScoreInfo(paras) {
  let getUrl = {
    method: "POST",
    url: "task/SaveTaskScoreInfo",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}
//新增打分项
export function AddScoreItem(paras) {
  let getUrl = {
    method: "POST",
    url: "task/AddScoreItem",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}
//新增打分组
export function AddScoreGroup(paras) {
  let getUrl = {
    method: "POST",
    url: "task/AddScoreGroup",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}
//删除打分项
export function DelScoreItem(itemId) {
  let getUrl = {
    method: "POST",
    url: "task/DelScoreItem?itemId=" + itemId,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
//删除打分组
export function DelScoreGroup(groupId) {
  let getUrl = {
    method: "POST",
    url: "task/DelScoreGroup?groupId=" + groupId,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
//获取所有打分组
export function GetScoreGroup() {
  let getUrl = {
    method: "GET",
    url: "task/GetScoreGroup",
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
/**
 * @description 根据devId获取设备
 * @constructor
 */
export function GetSSHLinkInfoById(devId) {
  let getUrl = {
    method: "GET",
    url: "DMS/GetSSHLinkInfoById",
    requestType: 2
  };
  let params = {
    devId: devId
  };
  return $http(getUrl, params);
}
//获取默认接收时长和人物等级默认对应关系
export function GetAllTaskNoticePolicy() {
  let getUrl = {
    method: "GET",
    url: "task/GetAllTaskNoticePolicy",
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
//获取通知策略
export function GetNoticeInstance(id, type) {
  let getUrl = {
    method: "GET",
    url:
      "NMS/GetNoticeInstanceInfoListByRelationId?relationId=" +
      id +
      "&relationType=" +
      type,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
//根据taskId获取任务进度
export function GetTaskKeyPathByTaskId(taskId) {
  let getUrl = {
    method: "GET",
    url: "task/GetTaskKeyPathByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(getUrl, params);
}
/*
 * 获取常用的关联主任务
 */
export function GetAllCommonSetTaskByServerId() {
  let getUrl = {
    method: "GET",
    url: "task/GetAllCommonSetTaskByServerId",
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
/*
 * 保存关联主任务
 */
export function AddSonTaskBySetCommonTask(paras) {
  let getUrl = {
    method: "POST",
    url: "task/AddSonTaskBySetCommonTask",
    requestType: 2
  };
  let params = {
    TASKCONTACT: paras
  };
  return $http(getUrl, params);
}
//获取通知详情
export function GetNoticeResult(id, type, relationId) {
  let getUrl = {
    method: "GET",
    url:
      "NMS/GetNoticeResultByRelationIdAndPolicyRelationId?relationId=" +
      id +
      "&relationType=" +
      type +
      "&policyRelationId=" +
      relationId,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

//通知策略详情
export function GetTransNoticePolicyAggr(id) {
  let getUrl = {
    method: "GET",
    url: "NMS/GetTransNoticePolicyAggrByInstanceId?instanceId=" + id,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

// 获取事件相关信息 任务详情展示界面需要
export function getEventByEventId(para) {
  let getUrl = {
    method: "GET",
    url: "task/GetEventByEventId",
    requestType: 2
  };
  let params = {
    eventId: para
  };
  return $http(getUrl, params);
}

// 获取任务详情
export function getTaskByTaskId(taskId, userId) {
  let getUrl = {
    method: "GET",
    url: "task/getTaskByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    userId: userId
  };
  return $http(getUrl, params);
}

// 获取服务台或者我的任务列表
export function getTaskListByParas(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetAttendanceTaskByPara",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 获取个人任务
 * @param {*} paras
 */
export function getAllCurrentUserTask(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetAllCurrentUserTask",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}
/**
 * 全文检索任务
 * @param {*} paras
 */

//获取结果集任务
export function GetTaskListByTaskIdList(idList, userId) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskListByTaskIdList",
    requestType: 2
  };
  let params = {
    IdList: idList,
    UserId: userId
  };
  return $http(getUrl, params);
}

export function GetTaskLuneceQuery(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskLuneceQuery",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

// var url=baseRepairURL+'task/GetAttendanceTaskByPara';
// return axios.post(url,{
//   AttendanceTaskParams:paras
// });

/**任务类型
 */
export function GetTaskTypeList() {
  let options = {
    method: "GET",
    url: "Task/GetTaskTypeList",
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

/**获取评论
 *
 */
export function GetCrisitismByMainId(
  crisitismId,
  crisitismType,
  topNum = null
) {
  let options = {
    method: "GET",
    url: `Task/GetCrisitismByMainId?crisitismId=${crisitismId}&crisitismType=${crisitismType}&topNum=${topNum}`,
    requestType: 2
  };
  return $http(options, {});
}

/**添加补充说明 百度上传
 * crisitism：补充说明对象
 */
export function AddCrisitism(crisitism, isNotice) {
  let options = {
    method: "POST",
    url: "Task/AddCrisitism",
    requestType: 2
  };
  let params = {
    Crisitism: crisitism,
    IsNotice: isNotice,
    FilePathList: []
  };
  return $http(options, params);
}

/**添加补充说明 饿了么上传
 * crisitism：补充说明对象
 */
export function AddCrisitism2(formData) {
  let options = {
    method: "POST",
    url: "Task/AddCrisitism2",
    requestType: 2,
    isFormData: true
  };
  return $http(options, formData);
}
/**跟踪记录
 * taskId：任务Id
 */
export function GetAllTaskKeyPointsByTaskId(taskId) {
  let options = {
    method: "GET",
    url: "Task/GetAllTaskKeyPointsByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(options, params);
}
/**子任务
 * taskId：任务Id
 */
export function GetAllSubTasksByParentTaskId(taskId) {
  let options = {
    method: "GET",
    url: "Task/GetAllSubTasksByParentTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    userId: cookieUser.userId
  };
  return $http(options, params);
}
/**工作计划
 * taskId：任务Id
 * mainType：类型 默认0
 */
export function GetWorkPlanByTaskId(taskId, mainType) {
  let options = {
    method: "GET",
    url: "Task/GetWorkPlanByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    mainType: mainType
  };
  return $http(options, params);
}

/**新增任务计划
 * plans：对象
 */
export function AddOrUpdateWorkPlan(plans, filePathList) {
  let options = {
    method: "POST",
    url: "Task/AddOrUpdateWorkPlan",
    requestType: 2
  };
  let params = {
    WorkPlan: plans,
    FilePathList: filePathList
  };

  return $http(options, params);
}
/**删除任务计划
 * plans：对象
 */
export function DelWorkPlan(plans) {
  let options = {
    method: "POST",
    url: "Task/DelWorkPlan",
    requestType: 2
  };
  let params = plans;
  return $http(options, params);
}

/**工作记录
 * taskId：任务Id
 * mainType：类型 默认0
 */
export function GetRecordInfoByMainId(mainId, mainType) {
  let options = {
    method: "GET",
    url: "Task/GetRecordInfoByMainId",
    requestType: 2
  };
  let params = {
    mainId: mainId,
    mainType: mainType,
    userId: cookieUser.userId
  };
  return $http(options, params);
}

/**新增工作记录
 * paras
 */
export function AddOrUpdateRecordInfo(info, fileList, isedit) {
  let options = {
    method: "POST",
    url: isedit ? "Task/EditRecordInfo" : "Task/AddRecordInfo",
    requestType: 2
  };
  let params = {
    Record: info,
    FilePathList: fileList
  };
  return $http(options, params);
}

/**任务干系人
 * taskId：任务Id
 * onlyNoticePerson：类型 默认0
 */
export function GetTaskMemeber(taskId, onlyNoticePerson) {
  let options = {
    method: "GET",
    url: "im/GetTaskMemeber",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    onlyNoticePerson: onlyNoticePerson
  };
  return $http(options, params);
}

/**新增干系人
 * TaskMemberList：干系人对象
 */
export function AddTaskMemberList(TaskMemberList) {
  let options = {
    method: "POST",
    url: "Task/AddTaskMemberList",
    requestType: 2
  };
  let params = {
    TaskMemberList: TaskMemberList,
    Person: person
  };
  return $http(options, params);
}

/**更新干系人
 * TaskMemberList：干系人对象
 */
export function UpdateTaskMemberList(TaskMemberList) {
  let options = {
    method: "POST",
    url: "Task/UpdateTaskMemberList",
    requestType: 2
  };
  let params = {
    TaskMemberList: TaskMemberList,
    Person: person
  };
  return $http(options, params);
}

/**删除干系人
 * TaskMemberList：干系人对象
 */
export function DelTaskMemeber(id) {
  let options = {
    method: "GET",
    url: "Task/DelTaskMemeber",
    requestType: 2
  };
  let params = {
    id: id
  };
  return $http(options, params);
}

/**任务关联
 * taskId：任务Id
 * type 默认0
 * selectIndex:默认0
 */
export function GetAllRelationsBySelectIndex(taskId, type, selectIndex) {
  let options = {
    method: "GET",
    url: "Task/GetAllRelationsBySelectIndex",
    requestType: 2
  };
  let params = {
    id: taskId,
    type: type,
    selectIndex: selectIndex
  };
  return $http(options, params);
}
/**新增任务关联
 * Relations：任务Id
 * Person 默认0
 */
export function addRelation(jobj) {
  let options = {
    method: "POST",
    url: "Task/AddRelation",
    requestType: 2
  };
  let params = jobj;
  return $http(options, params);
}
/**删除任务关联
 * taskId：任务Id
 * type 默认0
 * selectIndex:默认0
 */
export function DelRelation(relationId, person) {
  let options = {
    method: "POST",
    url: "Task/DelRelation",
    requestType: 2
  };
  let params = {
    RelationId: relationId,
    Person: person
  };
  return $http(options, params);
}

/**总结
 * taskId：任务Id
 */
export function GetAllMergeTaskSummaryByTaskId(taskId) {
  let options = {
    method: "GET",
    url: "Task/GetAllMergeTaskSummaryByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(options, params);
}
/**聊天人员
 * taskId：任务Id
 */
export function GetAllSessionsByTaskId(taskId) {
  let options = {
    method: "GET",
    url: "IM/GetAllSessionsByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(options, params);
}
/**聊天记录
 * taskId：任务Id
 */
export function GetHistoryMessage(fromId, toId, infoType, pageNum) {
  let options = {
    method: "GET",
    url: "IM/GetHistoryMessage",
    requestType: 2
  };
  let params = {
    fromId: fromId,
    toId: toId,
    infoType: infoType,
    pageNum: pageNum
  };
  return $http(options, params);
}
/**聊天记录
 * sessionId：任务聊天ID
 */
export function GetAllMessageBySessionId(sessionId) {
  let options = {
    method: "GET",
    url: "IM/GetAllMessageBySessionId",
    requestType: 2
  };
  let params = {
    sessionId: sessionId
  };
  return $http(options, params);
}

/**服务台
 * customerId：
 * speci：门户网站需要展示特定的几个服务台，默认为false不展示
 */
export function GetAllServerCenterByCustomerId(customerId, speci) {
  let options = {
    method: "GET",
    url: "Task/GetAllServerCenterByCustomerId",
    requestType: 2
  };
  let params = {
    customerId: customerId,
    speci: speci
  };
  return $http(options, params);
}
/**通过服务单新增任务
 * customerId：
 */
export function AddAssignTask(taskInfo, taskMeMberInfo) {
  let options = {
    method: "POST",
    url: "Task/AddAssignTask",
    requestType: 2
  };
  let params = {
    TaskInfo: JSON.stringify(taskInfo),
    TaskMeMberInfo: JSON.stringify(taskMeMberInfo)
  };
  return $http(options, params);
}
/**通过服务单新增任务
 * customerId：
 */
export function AddAssignFileTask(formData) {
  let options = {
    method: "POST",
    url: "Task/AddAssignTask",
    requestType: 2,
    isFormData: true
  };
  return $http(options, formData);
}

// TODO:获取当前人员可抢单的服务台
export function getAcceptTaskServerCenters(userId) {
  let options = {
    method: "GET",
    url: "Task/GetAcceptTaskServerCenters",
    requestType: 2
  };
  let params = {
    userId: userId
  };
  return $http(options, params);
}

// TODO:获取当前人已经登陆的服务台
export function GetAllManageServerCenterByUserId(userId) {
  let options = {
    method: "GET",
    url: "Task/GetAllManageServerCenterByUserId",
    requestType: 2
  };
  let params = {
    userId: userId
  };
  return $http(options, params);
}
// TODO:到处excal
export function GetAllTaskPerDayByServerCenterId(userId, beginTime, endTime) {
  let options = {
    method: "GET",
    url: "Task/GetAllTaskPerDayByServerCenterId",
    requestType: 2
  };
  let params = {
    serverCenterId: userId,
    beginTime: beginTime,
    endTime: endTime
  };
  return $http(options, params);
}
//TODO: 获取班次
export function GetAllBanci(id) {
  let options = {
    method: "GET",
    url: "Task/GetAllBanci",
    requestType: 2
  };
  let params = {
    serverCenTerId: id
  };
  return $http(options, params);
}

//TODO:获取报表服务台
export function GetAllServerCenterManageList(id) {
  let options = {
    method: "GET",
    url: "Task/GetAllServerCenterManageList",
    requestType: 2
  };
  let params = {
    serverCenTerId: id
  };
  return $http(options, params);
}
//TODO: 接收任务
export function acceptTask(paras) {
  let options = {
    method: "POST",
    url: "Task/AcceptTask",
    requestType: 2
  };
  let params = paras;
  return $http(options, params);
}

//TODO: 是否能够流转任务
export function canConvertTask(taskId, userId, deptId) {
  let options = {
    method: "GET",
    url:
      "Task/IsCanConvertTask?taskId=" +
      taskId +
      "&userId=" +
      userId +
      "&deptId=" +
      deptId,
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

//TODO: 流转任务
export function convertTask(wanderInfo, noticePersons) {
  let options = {
    method: "POST",
    url: "Task/ConvertTask",
    requestType: 2
  };
  let params = {
    wanderInfo: wanderInfo,
    noticePersonList: noticePersons
  };
  return $http(options, params);
}

//TODO: 催办
export function urgeTask(taskId, content, userId) {
  let options = {
    method: "GET",
    url: "Task/UrgeTask",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    content: content,
    createUserId: userId
  };
  return $http(options, params);
}
//TODO: 作废
export function cancelTask(taskId, person) {
  let options = {
    method: "POST",
    url: "Task/CancelTask",
    requestType: 2
  };
  let params = {
    ID: taskId,
    Person: person
  };
  return $http(options, params);
}

//TODO: 完成任务
export function completeTask(taskCompleteInfo, person, FilePathList) {
  let options = {};
  let params = {};

  options = {
    method: "POST",
    url: "Task/CompletTask",
    requestType: 2
  };
  params = {
    TaskCompleteInfo: taskCompleteInfo,
    Person: person,
    FilePathList: FilePathList
  };
  return $http(options, params);
}

// 打回
export function rebackTask(paras) {
  let options = {
    method: "POST",
    url: "Task/RebackTask",
    requestType: 2
  };
  let params = paras;
  return $http(options, params);
}

//评价
export function addEvaluation(evaInfo) {
  let options = {
    method: "POST",
    url: "Task/AddEvalution",
    requestType: 2,
    isFormData: true
  };
  return $http(options, evaInfo);
}
//关闭任务
export function closeTask(TaskOrEvent) {
  let options = {
    method: "POST",
    url: "Task/CloseTask",
    requestType: 2
  };
  let params = TaskOrEvent;
  return $http(options, params);
}
//获取卫宁事件分类
export function getWinningTaskType() {
  let options = {
    method: "GET",
    url: "Task/GetWinningTaskType",
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

//完成任务加上小结
export function completTaskSummary(task, taskSummary, faultTypeList) {
  let options = {
    method: "POST",
    url: "Task/CompletTaskSummary",
    requestType: 2
  };
  let params = {
    CompleteTask: task,
    SummaryInfo: taskSummary,
    FaultTypeInfo: faultTypeList
  };
  return $http(options, params);
}

//添加任务完成其他信息录入 卫宁用
export function addTaskCompleteExtendInfo(extendInfo) {
  let options = {
    method: "POST",
    url: "Task/AddTaskCompleteExtendInfo",
    requestType: 2
  };
  let params = {
    info: extendInfo
  };
  return $http(options, params);
}

//流转第三方系统
export function convertOtherSystem(taskCode, person) {
  let options = {
    method: "POST",
    url: "Task/ConvertOtherSystem",
    requestType: 2
  };
  let params = {
    taskCode: taskCode,
    person: person
  };
  return $http(options, params);
}

//获取所有的任务总结
export function getAllMergeTaskSummaryByTaskId(taskId) {
  let options = {
    method: "POST",
    url: "Task/GetAllMergeTaskSummaryByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(options, params);
}
//更改工时 卫宁用
export function updateTaskWorkload(taskId, workloadValue, workloadUnit) {
  let options = {
    method: "POST",
    url: "Task/UpdateTaskWorkload",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    workloadValue: workloadValue,
    workloadUnit: workloadUnit
  };
  return $http(options, params);
}

/**
 * @description  ConstTask 关注任务，参数:  MYFOCUSED(传false即设为关注，true即取消关注)  userId  taskId
 * @constructor
 */
export function ConstTask(myFocused, userId, taskId) {
  let options = {
    method: "POST",
    url:
      "Task/" +
      (myFocused == false ? "AddConstTask" : "DelConstTask") +
      "?userId=" +
      userId +
      "&taskId=" +
      taskId,
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}
/**
 * @description  AddConstGroupTask 关注任务添加分组 ConstGroup ConstTaskGroup
 * @constructor
 */
export function AddConstGroupTask(CONSTTASK, CONSTTASKGROUP) {
  let options = {
    method: "POST",
    url: "Task/AddConstGroupTask",
    requestType: 2
  };
  let params = {
    CONSTTASK: CONSTTASK,
    CONSTTASKGROUP: CONSTTASKGROUP ? CONSTTASKGROUP : ""
  }; // 选择分组的时候不需要传下面的分组，故可以只传constask
  return $http(options, params);
}

export function GetAllConstTaskGroup(userId, input) {
  let options = {
    method: "GET",
    url: "Task/GetAllConstTaskGroup",
    requestType: 2
  };
  let params = {
    userID: userId,
    input: input ? input : ""
  };
  return $http(options, params);
}

//获取所有打回事件原因（type=1，  0是总结原因）
export function GetAllEventReason(typeIndex) {
  let options = {
    method: "GET",
    url: "Task/GetAllEventReason",
    requestType: 2
  };
  let params = {
    type: typeIndex
  };
  return $http(options, params);
}
/**
 * @description  GetAllTaskGroup 获取任务分组
 * @constructor
 */
export function GetAllTaskGroup() {
  let options = {
    method: "GET",
    url: "Task/GetAllTaskGroup",
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}
/**
 * @description GetTaskwandersByTaskId根据taskId获取接收流转记录
 * @constructor
 */
export function GetTaskwandersByTaskId(taskId) {
  let options = {
    method: "GET",
    url: "Task/GetTaskwandersByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(options, params);
}
/**
 * @description  GetExcuteHumanList 获取接收人
 * @constructor
 */
export function GetExcuteHumanList(arr, input) {
  let options = {
    method: "GET",
    url: "user/GetAllSysUserReveivsOperUserByServerCenterID",
    requestType: 2
  };
  let params = {
    ServerCenterIds: arr.toString(),
    input: input
  };
  return $http(options, params);
}
/**
 * @description  GetServerCenterByUserId 获取当然人员所在的服务台
 * @constructor
 */
export function GetServerCenterByUserId(userId, userName, deptId, deptName) {
  let options = {
    method: "post",
    url: "task/GetServerCenterByUserId",
    requestType: 2
  };
  let params = {
    ID: userId,
    NAME: userName,
    DEPTID: deptId,
    DEPTNAME: deptName,
    COMPANYID: "",
    COMPANYNAME: ""
  };
  return $http(options, params);
}
/**
 * @description  上报任务 AddEvent // 请注意子任务不调用此接口！！！
 * @constructor
 */
export function AddEvent(formData) {
  let options = {
    method: "post",
    url: "task/AddEvent",
    requestType: 2,
    isFormData: true
  };
  return $http(options, formData);
}

/**
 * @description  上报修改任务 AddEvent // 请注意子任务不调用此接口！！！
 * @constructor
 */
export function EditEvent(formData) {
  let options = {
    method: "post",
    url: "task/EditEvent",
    requestType: 2,
    isFormData: true
  };
  return $http(options, formData);
}

export function AddTask(formData) {
  let options = {
    method: "post",
    url: "task/AddTask",
    requestType: 2,
    isFormData: true
  };
  return $http(options, formData);
}
/**
 * @description  上报任务 EditTask // 请注意子任务不调用此接口！！！
 * @constructor
 */
export function EditTask(formData) {
  let options = {
    method: "post",
    url: "task/EditTask",
    requestType: 2
  };
  return $http(options, formData);
}
/**
 * @description  根据用户的登录帐号获取一些信息 GetSysUserByCode
 * @constructor
 */
export function GetSysUserByCode(code) {
  let options = {
    method: "GET",
    url: "user/GetSysUserByCode",
    requestType: 2
  };
  let params = {
    Code: code
  };
  return $http(options, params);
}

export function GetAllEventResults(ipt) {
  let options = {
    method: "GET",
    url: "task/GetAllEventResults",
    requestType: 2
  };
  let params = {
    input: ipt
  };
  return $http(options, params);
}

//设成模板
export function AddTaskSearchTemplate(name, userId, deptId, content) {
  let options = {
    method: "post",
    url: "task/AddTaskSearchTemplate ",
    requestType: 2
  };
  let params = {
    NAME: name,
    USERID: userId,
    DEPTID: deptId,
    CONTENT: content
  };
  return $http(options, params);
}

//选择模板
export function GetTaskSearchTemplate(userId) {
  let options = {
    method: "get",
    url: "task/GetTaskSearchTemplate?userid=" + userId,
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

//删除模板
export function DelTaskSearchTemplate(templateId, userId) {
  let options = {
    method: "GET",
    url: "task/DelTaskSearchTemplate",
    requestType: 2
  };
  let params = {
    templateId: templateId,
    userId: userId
  };
  return $http(options, params);
}
export function GetTaskGroupTask(params) {
  let options = {
    method: "POST",
    url: "task/GetTaskGroupTask",
    requestType: 2
  };
  return $http(options, params);
}
export function AddGroupSubTask(subTaskIds, taskId) {
  let options = {
    method: "GET",
    url: "task/AddGroupSubTask",
    requestType: 2
  };
  let params = {
    subTaskIds: subTaskIds,
    taskId: taskId
  };
  return $http(options, params);
}
//任务总结
export function saveTaskSummary(jsonStr) {
  let options = {
    method: "POST",
    url: "task/saveTaskSummary",
    requestType: 2
  };
  let params = jsonStr;
  return $http(options, params);
}
//任务总结上传附件
export function UploadFiles(jsonStr) {
  let options = {
    method: "POST",
    url: "task/UploadFiles",
    requestType: 2,
    isFormData: true
  };
  let params = jsonStr;
  return $http(options, params);
}
/**获取上传的附件 */
export function GetFileInfoByTaskId(taskId, taskType) {
  let options = {
    method: "GET",
    url: "Task/GetFileInfoByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    taskType: taskType
  };
  return $http(options, params);
}
//查询任务明细（执行中）
export function getTaskSummaryByUserId(taskId, userId) {
  let options = {
    method: "GET",
    url: "task/GetTaskSummaryByUserId",
    requestType: 2
  };
  let params = {
    taskId: taskId,
    userId: userId
  };
  return $http(options, params);
}
//查询所有任务明细（已完成）
export function getAllTaskSummaryByTaskId(taskId) {
  let options = {
    method: "GET",
    url: "task/GetAllTaskSummaryByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(options, params);
}
//查询工作记录
export function GetAllRecordsByUserID(userId, input) {
  let options = {
    method: "GET",
    url: "task/GetAllRecordsByUserID",
    requestType: 2
  };
  let params = {
    userId: userId,
    input: input
  };
  return $http(options, params);
}
//获取设备产品对象树结构
export function GetCompanyAllGeneralSelTree(companyId, tag) {
  let options = {
    method: "GET",
    url: "basedata/GetCompanyAllGeneralSelTree",
    requestType: 2
  };
  let params = {
    companyId: companyId,
    tag: tag
  };
  return $http(options, params);
}
/**
 * 创建流程实例
 * @param {boolean} isNew -是否是新发起的实例
 * @param {string} processId -流程实例主键
 * @param {string} schemeCode -流程模板编号
 * @param {any} processName -流程标题
 * @param {any} processLevel -流程重要等级
 * @param {string} description -内容描述
 * @param {object} createUser -创建人
 * @param {object} auditers -审批人
 * @param {object} formData -自定义表单数据
 */
export function workflowCreate(
  isNew,
  processId,
  schemeCode,
  processName,
  processLevel,
  description,
  createUser,
  auditers,
  formData
) {
  let options = {
    method: "post",
    url:
      "WfEngine/Create?isNew=" +
      isNew +
      "&processId=" +
      processId +
      "&schemeCode=" +
      schemeCode +
      "&processName=" +
      processName +
      "&processLevel=" +
      processLevel +
      "&description=" +
      description +
      "&createUser=" +
      createUser +
      "&auditers=" +
      auditers +
      "&formData=" +
      formData,
    requestType: 1
  };
  let params = {
    // isNew: isNew,
    // processId: processId,
    // schemeCode: schemeCode,
    // processName: processName,
    // processLevel: processLevel,
    // description: description,
    // auditers: auditers,
    // formData: formData
  };
  return $http(options, params);
}

//获取所有模板
export function GetAllTemplateByUserId(userId, category) {
  let options = {
    method: "get",
    url:
      "basedata/GetAllTemplateByUserId?userid=" +
      userId +
      "&category=" +
      category,
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

//获取左侧显示模板
export function GetAllVisibleTemplateByUserId(userId, category) {
  let options = {
    method: "get",
    url:
      "basedata/GetAllVisibleTemplateByUserId?userid=" +
      userId +
      "&category=" +
      category,
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

//生成模板新接口
export function AddTemplate(
  name,
  icon,
  userId,
  createTime,
  content,
  tempType,
  index,
  pid,
  roleType,
  category
  // IsDefault = false
) {
  let options = {
    method: "POST",
    url: "basedata/AddTemplate",
    requestType: 2
  };
  let params = {
    NAME: name,
    ICON: icon,
    CREATEUSERID: userId,
    CREATETIME: createTime,
    CONTENT: content,
    TEMPTYPE: tempType,
    ORDERINDEX: index,
    PID: pid,
    ROLETYPE: roleType,
    CATEGORY: category
    //  IsDefault: IsDefault
  };
  return $http(options, params);
}

//删除模板新接口
export function DelTemplate(templateId, userId, type, newTemplateId) {
  let options = {
    method: "post",
    url: "basedata/DelTemplate",
    requestType: 2
  };
  let params = {
    TemplateId: templateId,
    UserId: userId,
    Type: type,
    NewTemplateId: newTemplateId
  };
  return $http(options, params);
}

//移除模板
export function HideTemplate(templateId, userId) {
  let options = {
    method: "post",
    url: "basedata/HideTemplate",
    requestType: 2
  };
  let params = {
    TemplateId: templateId,
    UserId: userId
  };
  return $http(options, params);
}

//拖拽模板

export function UpdateTemplateOrderIndex(templateId, orderIndex, userId, pid) {
  let options = {
    method: "post",
    url: "basedata/UpdateTemplateOrderIndex",
    requestType: 2
  };
  let params = {
    TemplateId: templateId,
    OrderIndex: orderIndex,
    UserId: userId,
    Pid: pid
  };
  return $http(options, params);
}

//拖拽模板
export function UpdateTemplateOrder(sortedList, userId) {
  let options = {
    method: "post",
    url: "basedata/UpdateTemplateOrder",
    requestType: 2
    // isFormData: true
  };
  let params = {
    sortedList,
    userId
  };
  return $http(options, params);
}

//修改模板
export function UpdateTemplate(template, category) {
  let options = {
    method: "post",
    url: "basedata/UpdateTemplate",
    requestType: 2
  };
  let params = {
    template: template,
    category: category
  };
  return $http(options, params);
}

//保存到左侧的模板SaveTemplateVisble
export function SaveTemplateVisble(temList, userId) {
  let options = {
    method: "post",
    url: "basedata/SaveTemplateVisble",
    requestType: 2
  };
  let params = {
    TemplateList: temList,
    UserId: userId
  };
  return $http(options, params);
}

/**
 * @descriptio  获取评价
 * @constructor
 */
export function GetEvalutionItemSet() {
  let getUrl = {
    method: "GET",
    url: "task/GetEvalutionItemSet",
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}
/**
 * @description 通过任务ID获取已保存的小结
 * @constructor
 */
export function GetAllListMergeTaskSuammryByTaskID(taskID) {
  let getUrl = {
    method: "GET",
    url: "task/GetAllListMergeTaskSuammryByTaskID",
    requestType: 2
  };
  let params = {
    taskID: taskID
  };
  return $http(getUrl, params);
}

//设置成默认模板
export function SetDefaultTemplate(
  templateId,
  userId,
  category,
  type = 0,
  isCancelDefault = false
) {
  let getUrl = {
    method: "GET",
    url: "basedata/SetDefaultTemplate",
    requestType: 2
  };
  let params = {
    templateId: templateId,
    userId: userId,
    category: category,
    type: type,
    isCancelDefault: isCancelDefault
  };
  return $http(getUrl, params);
}

//
export function GetAllCompanyDeptContactInfo() {
  let getUrl = {
    method: "GET",
    url: "basedata/GetAllCompanyDeptContactInfo",
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

//
export function AddTaskViewHistory(params) {
  let getUrl = {
    method: "POST",
    url: "task/AddTaskViewHistory",
    requestType: 2
  };
  return $http(getUrl, params);
}

export function GetTaskContentByTaskId(taskId) {
  let getUrl = {
    method: "GET",
    url: "task/GetTaskContentByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(getUrl, params);
}

//获取浏览记录
export function GetTaskViewHistory(pageIndex, pageSize, person) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskViewHistory",
    requestType: 2
  };
  let params = {
    PageIndex: pageIndex,
    PageSize: pageSize,
    Person: person
  };
  return $http(getUrl, params);
}

export function getNowFormatDate() {
  //  获取此刻时间
  var date = new Date();
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate =
    date.getFullYear() +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    date.getHours() +
    seperator2 +
    date.getMinutes() +
    seperator2 +
    date.getSeconds();
  return currentdate;
}

//}
export function listToTree(myId, pId, list) {
  const dic = new Map();
  const dic_1 = new Map();
  var len = list.length;
  for (var i = 0; i < len; i++) {
    dic.set(list[i][myId], list[i]);
    if (dic_1.has(list[i][pId])) {
      dic_1.get(list[i][pId]).push(list[i]);
    } else {
      dic_1.set(list[i][pId], [list[i]]);
    }
  }
  var nodes = [];
  for (var i = 0; i < len; i++) {
    if (!dic.has(list[i][pId])) {
      nodes.push(list[i]);
    }
  }
  var toDo = [];
  var len_1 = nodes.length;
  for (var i = 0; i < len_1; i++) {
    toDo.push(nodes[i]);
  }
  while (toDo.length) {
    var node = toDo.shift(); // the parent node
    if (dic_1.has(node[myId])) {
      var ls = dic_1.get(node[myId]);
      node.children = ls; //dic_1.get(node[myId]);
      for (var j = 0; j < ls.length; j++) toDo.push(ls[j]);
    }
  }
  return nodes; //树形菜单
}

//获取电话录音信息
export function GetPhoneDetail(eventId) {
  let getUrl = {
    method: "GET",
    url: "task/GetPhoneDetail",
    requestType: 2
  };
  let params = {
    eventId: eventId
  };
  return $http(getUrl, params);
}

//合并文件
export function MergeFile(guid, fileExt) {
  let getUrl = {
    method: "POST",
    url: "task/MergeFile",
    requestType: 2
  };
  let params = {
    guid: guid,
    fileExt: fileExt
  };
  return $http(getUrl, params);
}

//获取代办任务
export function GetBacklogTask(para) {
  let getUrl = {
    method: "POST",
    url: "task/GetBacklogTask",
    requestType: 2
  };
  return $http(getUrl, para);
}

//获取我所有要审批的延期申请
export function GetMyApproveTaskDelay(userId, approved, myApply) {
  let getUrl = {
    method: "get",
    url:
      "task/GetMyApproveTaskDelay?userId=" +
      userId +
      "&approved=" +
      approved +
      "&myApply=" +
      myApply,
    requestType: 2
  };
  return $http(getUrl, {});
}

//延期任务申请
export function DelayTask(taskDelay) {
  let getUrl = {
    method: "post",
    url: "task/DelayTask",
    requestType: 2
  };
  let params = {
    taskDelay: taskDelay
  };
  return $http(getUrl, taskDelay);
}

//审批任务延期申请
export function ApprovalTaskDelay(taskDelay) {
  let getUrl = {
    method: "post",
    url: "task/ApprovalTaskDelay",
    requestType: 2
  };
  let params = {
    taskDelay: taskDelay
  };
  return $http(getUrl, taskDelay);
}

//通过任务类型id获取任务类型
export function GetTaskTypeById(typeId) {
  let getUrl = {
    method: "get",
    url: "task/GetTaskTypeById?typeId=" + typeId,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

// export function UpdateTemplate(content) {
//   let options = {
//     method: 'post',
//     url: 'basedata/UpdateTemplate',
//     requestType: 2
//   }
//   let params = {
//     CONTENT: content,
//   }
//   return $http(options, params)
// }

//总结
// export  function  urgeTask(taskId,content,userId) {
//   let options = {
//     method: 'GET',
//     url: 'Task/AddorUpdateMergeTaskSummary',
//     requestType: 2
//   }
//   let params ={SummaryInfo:taskId,FaultTypeInfo:content,DeviceInfo:,RecordInfo:};
//   return $http(options, params)
// }

// 获取任务的延期申请记录
export function GetTaskDelayByTaskId(taskId) {
  let options = {
    method: "GET",
    url: "task/GetTaskDelayByTaskId",
    requestType: 2
  };
  let params = {
    taskId: taskId
  };
  return $http(options, params);
}

export function AddOrUpdateTaskType(params) {
  let options = {
    method: "POST",
    url: "task/AddOrUpdateTaskType",
    requestType: 2
  };
  return $http(options, params);
}

//不接收任务
export function RejectReciveTask(taskId, memo, person) {
  let options = {
    method: "POST",
    url: "task/RejectReciveTask",
    requestType: 2
  };
  let params = {
    TaskId: taskId,
    Memo: memo,
    Person: person
  };
  return $http(options, params);
}

// 任务统计
export function GetTaskStatsGroupByTaskType(params) {
  let options = {
    method: "POST",
    url: "task/GetTaskStatsGroupByTaskType",
    requestType: 2
  };
  return $http(options, params);
}

export function GetTaskCompleteStatsByDate(params) {
  let options = {
    method: "POST",
    url: "task/GetTaskCompleteStatsByDate",
    requestType: 2
  };
  return $http(options, params);
}

export function GetTaskStatsByTaskState(params) {
  let options = {
    method: "POST",
    url: "task/GetTaskStatsByTaskState",
    requestType: 2
  };
  console.log("GetTaskStatsByTaskState", JSON.stringify(params));
  return $http(options, params);
}

export function GetTaskDelayStats(params) {
  let options = {
    method: "POST",
    url: "task/GetTaskDelayStats",
    requestType: 2
  };
  return $http(options, params);
}

export function GetTaskDelayStatsByDate(params) {
  let options = {
    method: "POST",
    url: "task/GetTaskDelayStatsByDate",
    requestType: 2
  };
  return $http(options, params);
}

export function ProccessTaskPlan(workPlan, person) {
  let options = {
    method: "POST",
    url: "task/ProccessTaskPlan",
    requestType: 2
  };
  var params = {
    WorkPlan: workPlan,
    Person: person
  };
  return $http(options, params);
}

export function CompleteTaskPlan(workPlan, person) {
  let options = {
    method: "POST",
    url: "task/CompleteTaskPlan",
    requestType: 2
  };
  var params = {
    WorkPlan: workPlan,
    Person: person
  };
  return $http(options, params);
}

export function DelAttachFile(fileIds) {
  let options = {
    method: "POST",
    url: "task/DelAttachFile",
    requestType: 2
  };

  let params = {
    fileIds: fileIds
  };
  return $http(options, params);
}
// 修改任务名称
export function updateTaskName(person, taskid, newtaskname) {
  let options = {
    method: "POST",
    url: "task/UpdateTaskName",
    requestType: 2
  };
  let params = {
    Person: person,
    TaskId: taskid,
    TaskName: newtaskname
  };
  return $http(options, params);
}
// 获取任务工作记录
export function GetAllRecordByParam(pageIndex, pageSize, params) {
  let options = {
    method: "POST",
    url: `task/GetAllRecordByParam?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    requestType: 2
  };
  return $http(options, params);
}
// 获取任务工作记录
export function GetRecordById(recordid, userid) {
  let options = {
    method: "GET",
    url: `task/GetRecordById?recordId=${recordid}&userId=${userid}`,
    requestType: 2
  };
  return $http(options, {});
}

//获取任务标签
export function GetTaskTag(input) {
  let options = {
    method: "GET",
    url: `task/GetTaskTag?input=${input}`,
    requestType: 2
  };
  return $http(options, {});
}
//新增工作集
export function AddRecordReport(model) {
  let options = {
    method: "POST",
    url: `task/AddRecordReport`,
    requestType: 2
  };
  return $http(options, model);
}

/**
 *根据任务ID获取工作记录 多任务ID
 * @export
 * @param {*} taskId 多任务ID已逗号隔开
 * @param {*} orderType 排序方式  1创建人 2执行人员 3创建时间 4记录创建人 5记录创建时间
 * @returns
 */
export function GetRecordsByTaskId(taskId, orderType) {
  let options = {
    method: "POST",
    url: `task/GetRecordsByTaskId`,
    requestType: 2
  };
  return $http(options, {
    TaskId: taskId,
    OrderType: orderType,
    UserId: cookieUser.userId
  });
}
//获取工作报告
export function GetRecordLuneceQuery(
  pageIndex,
  pageSize,
  keyWord,
  recordLunecePara
) {
  let options = {
    method: "POST",
    url: `task/GetRecordLuneceQuery?pageIndex=${pageIndex}&pageSize=${pageSize}&keyWord=${keyWord}`,
    requestType: 2
  };
  return $http(options, recordLunecePara);
}
//新增工作记录关联
export function AddRecordRelation(relations) {
  let options = {
    method: "POST",
    url: `task/AddRecordRelation`,
    requestType: 2
  };
  return $http(options, {
    Relations: relations,
    Person: person
  });
}
//删除工作记录关联
export function DelRecordRelation(relationId) {
  let options = {
    method: "POST",
    url: `task/DelRecordRelation`,
    requestType: 2
  };
  return $http(options, {
    RelationId: relationId,
    Person: person
  });
}

//修改任务关联
export function UpdateRelation(relation, person) {
  let options = {
    method: "POST",
    url: `task/UpdateRelation`,
    requestType: 2
  };
  return $http(options, {
    Relation: relation,
    Person: person
  });
}

//新增工作记录关注
export function AddFocusRecord(focusRecord) {
  let options = {
    method: "POST",
    url: `task/AddFocusRecord`,
    requestType: 2
  };
  return $http(options, focusRecord);
}

//取消工作记录关注
export function DelFocusRecord(recordId, person) {
  let options = {
    method: "POST",
    url: `task/DelFocusRecord?recordId=${recordId}`,
    requestType: 2
  };
  return $http(options, person);
}

// 获取我分配的
export function GetMyCreateTaskStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyCreateTaskStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 获取别人分配的
export function GetOtherCreateTaskStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetOtherCreateTaskStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 获取我值班服务台期间未处理,已处理的任务
export function GetMyServerCenterStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyServerCenterStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 我未接收的
export function GetMyUnReciveTaskStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyUnReciveTaskStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 我已接收的
export function GetMyRecivedTaskStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyRecivedTaskStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 我待处理的
export function GetMyProcessingTaskStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyRecivedTaskStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 我处理过的
export function GetMyCompletedTaskStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyRecivedTaskStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 我逾期的
export function GetMyOutDateTaskStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyOutDateTaskStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 逾期 我的服务台
export function GetMyOutServerOrUserStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetMyOutServerOrUserStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 任务汇总
export function GetTaskTypeStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetTaskTypeStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 任务状态数量
export function GetTaskTypePerStateStatistics(paras) {
  let options = {
    method: "POST",
    url: `task/GetTaskTypePerStateStatistics`,
    requestType: 2
  };
  return $http(options, paras);
}

// 任务权限，获取具有任务权限的机构组织和服务台
export function GetTaskHasAuthTeam(userId) {
  let options = {
    method: "GET",
    url: `basedata/GetTaskHasAuthTeam?userId=${userId}`,
    requestType: 2
  };
  return $http(options, {});
}

export function GetGroupByTaskID(taskId) {
  let options = {
    method: "GET",
    url: `task/GetGroupByTaskID?taskId=${taskId}`,
    requestType: 2
  };
  return $http(options, {});
}
/**
 * 获取任务中群聊天记录
 * @param {*} groupId
 */
export function GetPubMessagesByGroupId(groupId) {
  let options = {
    method: "GET",
    url: `task/GetPubMessagesByGroupId?groupId=${groupId}`,
    requestType: 2
  };
  return $http(options, {});
}

/**
 * 添加任务跟踪记录
 * @param {*} task 任务实体
 * @param {*} content 内容
 */
export function AddTaskKeyPoint(task, content) {
  let options = {
    method: "POST",
    url: `task/AddTaskKeyPoint`,
    requestType: 2
  };
  var params = {
    ID: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }),
    TASKID: task.ID,
    CREATEUSERID: cookieUser.userId,
    CREATEUSERNAME: cookieUser.realName,
    CREATEDEPTID: cookieUser.departmentId,
    CREATEDEPTNAME: cookieUser.departmentName,
    KEYPOINTNAME: content,
    MEMO: "",
    STATE: task.STATE,
    OPERATETIME: new Date(),
    CREATECOMPANYID: cookieUser.companyId,
    CREATECOMPANYNAME: cookieUser.companyName
  };
  return $http(options, params);
}

/**
 * 获取任务所有附件
 * @param {*} taskId
 */
export function GetAllFilesByTaskId(taskId) {
  let options = {
    method: "GET",
    url: `task/GetAllFilesByTaskId`,
    requestType: 2
  };
  return $http(options, {
    taskId: taskId
  });
}

/**
 * 根据事件或者任务Id获取电话任务的详情
 * @param {*} eventId
 */
export function GetAllPhoneTaskByEventId(eventId) {
  let options = {
    method: "GET",
    url: `task/GetAllPhoneTaskByEventId`,
    requestType: 2
  };
  return $http(options, {
    eventId: eventId
  });
}
/**
 * 获取本机构id
 * @param {*}
 */
export function GetSelfCompanyEx() {
  let options = {
    method: "GET",
    url: "/serverDuty/GetSelfCompanyEx",
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

/**
 * 获取任务消息关联通知策略
 *
 */
export function GetTaskMsgNoticePolicy(tasktype) {
  let options = {
    method: "GET",
    url: `task/GetTaskMsgNoticePolicy?tasktype=${tasktype}`,
    requestType: 2
  };
  return $http(options, {});
}
/**
 * 新增或修改任务消息关联通知策略
 *@param {*} model
 */
export function AddOrUpdateTaskMsgNoticePolicy(model) {
  let options = {
    method: "POST",
    url: `task/AddOrUpdateTaskMsgNoticePolicy`,
    requestType: 2
  };
  return $http(options, model);
}

/**
 * 保存任务消息通知策略
 *@param {*} array
 */
export function SaveTaskMsgNoticePolicy(array) {
  let options = {
    method: "POST",
    url: `task/SaveTaskMsgNoticePolicy`,
    requestType: 2
  };
  return $http(options, {
    "": array
  });
}

/**
 * 获取服务台任务
 * @param {*} paras
 */
export function GetAllServerCenterTask(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetAllServerCenterTask",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 知识库
 */
export function SearchKnowledge(paras) {
  let getUrl = {
    method: "POST",
    url: "KMS/SearchKnowledge",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 修改任务干系人关注度
 */
export function UpdateTaskMemberFocusDegree(TaskId, UserId, FocusDegree) {
  let getUrl = {
    method: "POST",
    url: "task/UpdateTaskMemberFocusDegree",
    requestType: 2
  };
  let params = {
    TaskId: TaskId,
    UserId: UserId,
    FocusDegree: FocusDegree
  };
  return $http(getUrl, params);
}

/**
 * 修改任务干系人是否是负责人
 */
export function UpdateTaskMemberMonitor(TaskId, person, IsMonitor) {
  let getUrl = {
    method: "POST",
    url: "task/UpdateTaskMemberMonitor",
    requestType: 2
  };
  let params = {
    TaskId: TaskId,
    Person: person,
    IsMonitor: IsMonitor
  };
  return $http(getUrl, params);
}

/**
 * 工作看板：人员
 */
export function GetUserListByListCompanyDeptIdWithTaskPost(paras) {
  let getUrl = {
    method: "POST",
    url: "basedata/GetUserListByListCompanyDeptIdWithTaskPost",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 工作看板：总览
 */
export function GetTaskOverviewStatistics(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskOverviewStatistics",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 工作看板：左侧
 */
export function GetRepairTaskStatistics(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetRepairTaskStatistics",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 工作看板：右侧
 */
export function GetTaskTypeStateStatisticsExceptRepair(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskTypeStateStatisticsExceptRepair",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 工作看板 状态视图获取
 */
export function GetTaskStatePerTypeStatistics(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskStatePerTypeStatistics",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

/**
 * 工作看板：列表
 */
export function GetTaskListByCodeList(paras) {
  let getUrl = {
    method: "POST",
    url: "task/GetTaskListByCodeList",
    requestType: 2
  };
  let params = paras;
  return $http(getUrl, params);
}

export function GetTaskSupplyByTaskId(taskId) {
  let getUrl = {
    method: "GET",
    url: "task/GetTaskSupplyByTaskId?taskId=" + taskId,
    requestType: 2
  };
  return $http(getUrl, {});
}
export function AddTaskSupply(formdata) {
  let getUrl = {
    method: "POST",
    url: "task/AddTaskSupply",
    requestType: 2,
    isFormData: true
  };
  return $http(getUrl, formdata);
}

//获取所有未读消息
export function GetUnReadRemind(pageIndex, pageSize, userId, relationType) {
  let getUrl = {
    method: "GET",
    url: `im/GetUnReadRemind?pageIndex=${pageIndex}&pageSize=${pageSize}&userId=${userId}&relationType=${relationType}`,
    requestType: 2
  };
  return $http(getUrl, {});
}

//消息设为已读
export function ReadRemind(remindIds) {
  let getUrl = {
    method: "POST",
    url: "im/ReadRemind",
    requestType: 2
  };
  console.log("remindIds", remindIds);
  return $http(getUrl, {
    "": remindIds
  });
}

/**
 * 获取评论
 */
export function GetCrisitismById(crisitismId) {
  let getUrl = {
    method: "GET",
    url: "task/GetCrisitismById?crisitismId=" + crisitismId,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

export function UpdateRecordDegree(recordId, degree) {
  let getUrl = {
    method: "POST",
    url: `task/UpdateRecordDegree`,
    requestType: 2
  };
  let params = {
    RecordId: recordId,
    Degree: degree
  };
  return $http(getUrl, params);
}

/**
 * 获取报警任务最新一次报警时间
 */
export function GetLastAlarmTimeByTaskId(taskId) {
  let getUrl = {
    method: "GET",
    url: `dms/GetLastAlarmTimeByTaskId?taskId=${taskId}`,
    requestType: 2
  };

  return $http(getUrl, {});
}

/**
 * 修改用户菜单模板是否可见
 * @param {*} templateId
 * @param {*} userId
 * @param {*} Visible
 */
export function UpdateTemplateUserSetting(templateId, userId, Visible) {
  let options = {
    method: "post",
    url: "basedata/UpdateTemplateUserSetting",
    requestType: 2
  };
  let params = {
    TemplateId: templateId,
    UserId: userId,
    Visible: Visible
  };
  return $http(options, params);
}

/**
 *获取组织看板每种状态下各服务台逾期数量
 *组织看板用    {DelayIndex:'',TaskCodeList:[]}
 * @export
 * @param {*} para
 * @returns
 */
export function GetDeptOutOfTimeStatistics(para) {
  let getUrl = {
    method: "POST",
    url: `task/GetDeptOutOfTimeStatistics`,
    requestType: 2
  };

  return $http(getUrl, para);
}

/**
 * 获取工作轨迹下所有的事件和关联任务
 *
 */
export function GetAllTaskKeyPointsByUser(query) {
  let options = {
    method: "POST",
    url: "task/GetAllTaskKeyPointsByUser",
    requestType: 2
  };

  let params = query;
  return $http(options, params);
}
/**
 * 删除任务
 * @param {*} TaskId
 * @param {*} Person
 */
export function DelTaskByTaskId(TaskId, Person) {
  let options = {
    method: "POST",
    url: "task/DelTaskByTaskId",
    requestType: 2
  };
  let params = {
    TaskId: TaskId,
    Person: Person
  };
  return $http(options, params);
}

/**
 *
 *取消点赞
 * @export
 * @param {*} mainId
 * @param {*} mainType
 * @param {*} person
 */
export function DelVote(mainId, mainType, person) {
  let options = {
    method: "POST",
    url: "task/DelVote",
    requestType: 2
  };
  let params = {
    MainId: mainId,
    MainType: mainType,
    Person: person
  };
  return $http(options, params);
}

/**
 *点赞
 *
 * @export
 * @param {*} voteInfo
 */
export function AddVote(voteInfo) {
  let options = {
    method: "POST",
    url: "task/AddVote",
    requestType: 2
  };
  return $http(options, voteInfo);
}
/**
 *根据工作记录获取工作记录关联
 *
 * @export
 * @param {*} recordId
 * @returns
 */
export function GetRecordRelationByRecordId(recordId) {
  let options = {
    method: "GET",
    url: "task/GetRecordRelationByRecordId",
    requestType: 2
  };
  return $http(options, {
    recordId: recordId
  });
}
/**
 *删除评论
 *
 * @export
 * @param {*} model
 * @returns
 */
export function DelCrisitism(model) {
  let options = {
    method: "POST",
    url: "task/DelCrisitism",
    requestType: 2
  };
  return $http(options, model);
}
/**
 *新增或编辑任务
 * @export
 * @param {*} model
 * @param {*} isNew
 * @returns
 */
export function AddOrUpdateTask(model, isNew) {
  let options = {
    method: "POST",
    url: `task/${isNew ? "AddTask" : "EditTask"}`,
    requestType: 2,
    isFormData: true
  };
  return $http(options, model);
}
/**
 *变更工作记录状态
 *
 * @export
 * @param {*} state
 * @param {*} person
 * @returns
 */
export function ChangeRecordState(state, recordId, person) {
  let options = {
    method: "POST",
    url: `task/ChangeRecordState`,
    requestType: 2
  };
  return $http(options, {
    State: state,
    RecordId: recordId,
    Person: person
  });
}
/**
 *添加标签
 *
 * @export
 * @param {*} tag
 * @returns
 */
export function AddTag(tag) {
  let options = {
    method: "POST",
    url: `task/AddTag`,
    requestType: 2
  };
  return $http(options, tag);
}
/**
 *
 *添加任务标签
 * @export
 * @param {*} taskTag
 * @returns
 */
export function AddTaskTag(taskTag) {
  let options = {
    method: "POST",
    url: `task/AddTaskTag`,
    requestType: 2
  };
  return $http(options, taskTag);
}

/**
 *删除任务标签
 *
 * @export
 * @param {*} taskTagId
 * @param {*} person
 * @returns
 */
export function DelTaskTag(taskTagId, person) {
  let options = {
    method: "POST",
    url: `task/DelTaskTag`,
    requestType: 2
  };
  return $http(options, {
    TaskTagId: taskTagId,
    Person: person
  });
}
/**
 *获取所有的标签
 *
 * @export
 * @returns
 */
export function getAllTag() {
  let options = {
    method: "GET",
    url: `task/GetAllTag`,
    requestType: 2
  };
  return $http(options, {});
}
/**
 *获取常用的标签
 *
 * @export
 * @param {*} userId
 * @returns
 */
export function getCommonTag(userId) {
  let options = {
    method: "GET",
    url: `task/GetCommonTag?userId=${userId}`,
    requestType: 2
  };
  return $http(options, {});
}
/**
 *删除标签
 *
 * @export
 * @param {*} tag
 * @returns
 */
export function DelTag(tagId, person) {
  let options = {
    method: "POST",
    url: `task/DelTag`,
    requestType: 2
  };
  return $http(options, {
    TagId: tagId,
    Person: person
  });
}
/**
 *通过任务ID获取任务标签
 *
 * @export
 * @param {*} tag
 * @returns
 */
export function GetTaskTagByTaskId(tag) {
  let options = {
    method: "GET",
    url: `task/GetTaskTagByTaskId`,
    requestType: 2
  };
  return $http(options, tag);
}

/**
 *保存任务标签
 *
 * @export
 * @param {*} tags
 *  @param {*}  taskId
 * @returns
 */
export function SaveTaskTags(tags, taskId) {
  let options = {
    method: "POST",
    url: `task/SaveTaskTags`,
    requestType: 2
  };
  return $http(options, {
    Tags: tags,
    TaskId: taskId
  });
}

/**
 *编辑标签
 *
 * @export
 * @param {*} tag
 * @returns
 */
export function EditTag(tag) {
  let options = {
    method: "POST",
    url: `task/EditTag`,
    requestType: 2
  };
  return $http(options, tag);
}
/**
 *
 *
 * @export
 * @param {*} tagId
 * @returns
 */
export function DelCommonTag(tagId, person) {
  let options = {
    method: "POST",
    url: `task/DelCommonTag`,
    requestType: 2
  };
  return $http(options, {
    TagId: tagId,
    Person: person
  });
}

/**
 *添加常用标签
 *
 * @export
 * @param {*} tag
 * @returns
 */
export function AddCommonTag(tag) {
  let options = {
    method: "POST",
    url: `task/AddCommonTag`,
    requestType: 2
  };
  return $http(options, tag);
}
/**
 *获取已读标签
 *
 * @export
 * @param {*} remindPara
 * @returns
 */
export function GetReadRemind(remindPara) {
  let options = {
    method: "POST",
    url: `im/GetReadRemind`,
    requestType: 2
  };
  return $http(options, remindPara);
}
/**
 *设置全部已读
 *
 * @export
 * @param {*} userId
 * @returns
 */
export function ReadAllRemind(userId) {
  let options = {
    method: "POST",
    url: `im/ReadAllRemind?userId=${userId}`,
    requestType: 2
  };
  return $http(options, {});
}

/**
 *提醒任务干系人关注
 *
 * @export
 * @param {*} taskMember，person
 * @returns
 */
export function RemindTaskMemberFocus(taskMember, person) {
  let options = {
    method: "POST",
    url: `task/RemindTaskMemberFocus`,
    requestType: 2
  };
  return $http(options, {
    TaskMember: taskMember,
    Person: person
  });
}

/**
 *通过任务ID获取任务来源
 *
 * @export
 * @param {*} taskId
 * @returns
 */
export function GetTaskOriginByTaskId(taskId) {
  let options = {
    method: "get",
    url: `task/GetTaskOriginByTaskId?taskId=${taskId}`,
    requestType: 2
  };
  return $http(options, {});
}
/**
 *通过工作记录ID获取工作记录 （多条）
 *
 * @export
 * @param {*} recordIds
 * @param {*} userId
 * @returns
 */
export function GetRecordListByIds(recordIds, userId) {
  let options = {
    method: "get",
    url: `task/GetRecordListByIds?recordIds=${recordIds}&userId=${userId}`,
    requestType: 2
  };
  return $http(options, {});
}
/**
 *保存工作记录完成总结
 *
 * @export
 * @param {*} completeInfo
 * @param {*} fileList
 * @returns
 */
export function saveRecordCompleteInfo(completeInfo, fileList) {
  let options = {
    method: "post",
    url: `task/SaveRecordCompleteInfo`,
    requestType: 2
  };
  return $http(options, {
    CompleteInfo: completeInfo,
    FileList: fileList
  });
}
/**
 *
 *删除工作记录
 * @export
 * @param {*} recordId
 * @returns
 */
export function DelRecord(recordId) {
  let options = {
    method: "post",
    url: `task/DelRecordById?recordId=${recordId}`,
    requestType: 2
  };
  return $http(options, {});
}

//获取左侧显示模板
export function GetTemplateMenu(userId) {
  let options = {
    method: "get",
    url: "basedata/GetTemplateMenu?userid=" + userId,
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

//获取任务跟踪记录分页
export function GetTaskKeyPointsPerPageByTaskId(pageIndex, pageSize, taskId) {
  let options = {
    method: "get",
    url:
      "task/GetTaskKeyPointsPerPageByTaskId?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize +
      "&taskId=" +
      taskId,
    requestType: 2
  };
  let params = {};
  return $http(options, params);
}

/**
 *获取所有任务类型
 *
 * @export
 * @param {*} index 0是禁用 1是启用 2是所有
 * @returns
 */
export function GetAllTaskTypeByIndex(index) {
  let options = {
    method: "get",
    url: `task/GetAllTaskTypeByIndex?index=${index}`,
    requestType: 2
  };

  return $http(options, {});
}

/**
 *启用禁用任务类型
 *
 * @export
 * @param {*} id
 * @param {*} isEable
 * @returns
 */
export function EnableTaskType(id, isEable) {
  let options = {
    method: "get",
    url: `task/EnableTaskType?Id=${id}&isEnable=${isEable}`,
    requestType: 2
  };

  return $http(options, {});
}

/**
 *获取任务类型模板设置
 *
 * @export
 * @returns
 */
export function GetVWCompanyExByGeneralCode(orgId) {
  let options = {
    method: "GET",
    url: `task/GetVWCompanyExByGeneralCode`,
    requestType: 2
  };

  let params = {
    orgId: orgId
  };
  return $http(options, params);
}
/**
 *设置工作记录关联排序
 *
 * @export
 * @param {*} array
 * @returns
 */
export function SetRecordRelationSort(array, recordId) {
  let options = {
    method: "POST",
    url: `task/SetRecordRelationSort`,
    requestType: 2
  };

  let params = {
    RelationList: array,
    RecordId: recordId
  };
  return $http(options, params);
}
/**
 *移除工作记录关联
 *
 * @export
 * @param {*} relationId
 * @param {*} recordId
 * @returns
 */
export function RemoveRecordRelation(relationId, recordId) {
  let options = {
    method: "POST",
    url: `task/RemoveRecordRelation`,
    requestType: 2
  };

  let params = {
    RelationId: relationId,
    RecordId: recordId
  };
  return $http(options, params);
}

/**
 * 新增任务关联
 *
 * @export
 * @param {*} relations
 * @returns
 */
export function AddTaskRelation(relations) {
  let options = {
    method: "POST",
    url: `task/AddTaskRelation`,
    requestType: 2
  };

  let params = {
    "": relations
  };
  return $http(options, params);
}

/**
 *修改任务关联
 *
 * @export
 * @param {*} relations
 * @param {*} person
 * @returns
 */
export function UpdateTaskRelation(relations, person) {
  let options = {
    method: "POST",
    url: `task/UpdateTaskRelation`,
    requestType: 2
  };

  let params = {
    Relation: relations,
    Person: person
  };
  return $http(options, params);
}

/**
 *删除任务关联
 *
 * @export
 * @param {*} relationId
 * @param {*} person
 * @returns
 */
export function DelTaskRelation(relationId, person) {
  let options = {
    method: "POST",
    url: `task/DelTaskRelation`,
    requestType: 2
  };

  let params = {
    RelationId: relationId,
    Person: person
  };
  return $http(options, params);
}

/**
 *通过任务ID获取任务关联
 *
 * @export
 * @param {*} taskId
 * @returns
 */
export function GetTaskRelationByTaskId(taskId) {
  let options = {
    method: "GET",
    url: `task/GetTaskRelationByTaskId?taskId=${taskId}`,
    requestType: 2
  };
  return $http(options, {});
}
